import React from 'react';
import styled, { css } from 'styled-components';
import { CloudDownload } from '@material-ui/icons';
import { black, gray, red } from '@avangard/ui/colors';

export type UploadHandlerProps = {
    title: string;
    onClick: () => void;

    disabled?: boolean;
    icon?: React.ReactNode;
    withoutIcon?: boolean;
    dense?: boolean;
    className?: string;
};

const Handler = styled.div<Pick<UploadHandlerProps, 'disabled' | 'dense'>>`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 32px;
    padding: 4px 16px;
    color: ${black[54]};
    border: 1px dashed ${gray[40]};
    border-radius: 4px;
    transition: 0.2s;
    cursor: pointer;

    &:hover {
        color: ${red[50]};
        border-color: ${red[50]};
    }

    ${p =>
        !!p.disabled &&
        css`
            pointer-events: none;
            opacity: 0.6;

            &:hover {
                color: ${black[54]};
                border: 1px dashed ${gray[40]};
            }
        `}

    ${p =>
        !!p.dense &&
        css`
            min-height: initial;
        `}
`;

const Content = styled.div`
    display: flex;
    align-items: center;
    font-size: 1.4rem;

    > span {
        display: inline-flex;
        margin-inline-end: 8px;
        color: ${black[54]};
    }

    > p {
        line-height: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

const uploadIcon = <CloudDownload style={{ fontSize: 16 }} />;

const UploadHandler = (props: UploadHandlerProps): React.ReactElement => {
    const { title, disabled, icon = uploadIcon, withoutIcon, onClick, ...otherProps } = props;

    const handleClick = () => {
        if (disabled) {
            return;
        }

        onClick();
    };

    return (
        <Handler disabled={disabled} onClick={handleClick} {...otherProps}>
            <Content>
                {!withoutIcon ? <span>{icon}</span> : null}
                <p>{title}</p>
            </Content>
        </Handler>
    );
};

export { UploadHandler };
